var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonEmployeeDetailsModal',{attrs:{"title":"Manage Away Type"}},[_c('SchoolAwayDetailEditForm',{attrs:{"is-busy":_vm.isBusy,"form-set":_vm.selectedAway},on:{"handle-submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }